import React from 'react';
import logo from "../../assets/logo/logo.png";
import "./BigScreen.css";

const BigScreen = () => {
  return (
    <div className="bigScreenContainer">
      <div className="bigScreenContent">
        <div className="bigScreenLogo">
          <img src={logo} alt="Musie Residence Logo" className="bigScreenLogoImg" />
          <div className="bigScreenLogoText">
            <p className="bigScreenLogoName">Musie Residence</p>
          </div>
        </div>
        <div className="bigScreenMessage">
          <p className="bigScreenMessageText">
            Дорогие гости, приложение бота Резиденции предназначено только для мобильных устройств. К сожалению, оно не поддерживается на планшетах. Откройте, пожалуйста, с мобильного устройства. Спасибо!
          </p>
        </div>
      </div>
    </div>
  );
};

export default BigScreen;